import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { ShoppingCartData } from '@models/shopping-cart.model';
import { DeviceItemDevice, DeviceItemDeviceBP } from '@models/shopping.model';
import { CustomizeService } from '@services/customize-service/customize.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'ts-device-description',
  templateUrl: './device-description.component.html',
  imports: [CommonModule]
})
export class DeviceDescriptionComponent implements OnInit, OnDestroy {
  @Input() device: DeviceItemDevice | DeviceItemDeviceBP;
  @Input() is_bp_device: boolean | undefined;
  shopping_cart: ShoppingCartData;
  private subscriptions: Subscription = new Subscription();

  constructor(private customize_svc: CustomizeService) {}

  ngOnInit(): void {
    this.subscriptions.add(
      this.customize_svc.cartChanges.subscribe(
        (res: ShoppingCartData) => (this.shopping_cart = res)
      )
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  constructAssetTitle = (): string =>
    `${this.device.manufacturer} ${this.device.model} ${this.device.size} ${this.device.original_color}`;

  constructBusinessPurpose = (): string => (this.device as DeviceItemDeviceBP).business_purpose;
}
